import { k } from "../kaplay";

export function createDecor(){
  const sprites = [
    {
      name: "mushroom",
      quantity: 10,
      priority: 1,
      angles: [0, 0]
    },
    {
      name: "steel",
      quantity: 50,
      priority: 0,
      angles: [0, 360]
    },
    {
      name: "skull",
      quantity: 2,
      priority: 2,
      angles: [-45, 45]
    },
  ]

  for (let sprite of sprites){
    for (let i = 0; i < sprite.quantity; i++){
      k.add([
        "decor",

        k.sprite(sprite.name),
        k.layer("backbackground"),
        k.pos(k.randi(0, k.width()), k.randi(0, k.height())),
        k.color(k.Color.fromHex("#674770")),
        k.opacity(0.05),
        k.area(),
        k.stay(),
        k.rotate(k.randi(sprite.angles[0], sprite.angles[1])),

        { priority: sprite.priority }
      ])
    }
  }

  k.onCollide("decor", "decor", async (decor1, decor2) => {
    if (decor1.priority > decor2.priority) decor2.destroy();
    else if (decor2.priority > decor1.priority) decor1.destroy();

    decor2.destroy();
  })
}